import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"

export default class extends Controller {
  initialize() {
    Loggable(this, { debug: false })
  }
  connect() {
    this.log("connected")
  }

}
